(function(){
    'use strict'

    angular
    .module('app.organizadores')
    .controller('EditarOrganizador', EditarOrganizador);

    EditarOrganizador.$inject = ['$scope', '$animationsSrv', '$routeParams', 'OrganizadoresService', 'logger', '$location', 'UserInfoService'];

    function EditarOrganizador($scope, $animationsSrv, $routeParams, OrganizadoresService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.organizador;

        var organizadorId = $routeParams.id ? $routeParams.id : 0;

        getOrganizador();

        function getOrganizador(){

            if(organizadorId != 0){
                var promise = OrganizadoresService.getById(organizadorId);

                promise
                .then(function(organizador){
                    vm.organizador = organizador;
                })
                .catch(function(error){
                    logger.error('Hubo un erro al obtener los datos');
                });               
            }

        };

        vm.save = function(){             
            $scope.submitted = true;

            if($scope.organizadorForm.$valid){
                if(!vm.organizador.id){
                    saveOrganizador();
                }
                else if($scope.organizadorForm.$dirty){
                    updateOrganizador();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }
        };

        function saveOrganizador(){
            vm.organizador.id = 0;

            var promise = OrganizadoresService.save(vm.organizador);
            
            promise
            .then(function(response){
                logger.success('Organizador creado con éxito.');
                clearOrganizadorData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un erro al crear el organizador'  + error.data.Message);
                        break;
                }
            });  
        };

        function updateOrganizador(){

            var promise = OrganizadoresService.update(vm.organizador);
            
            promise
            .then(function(response){
                logger.success('Organizador modificado con éxito.');
                $location.path('/organizadores');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un erro al modificar el organizador: ' + error.data.Message);
                        break;
                }
            });  
        };

        function clearOrganizadorData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.organizador = {};
            // Set back to pristine.
            $scope.organizadorForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.organizadorForm.$setUntouched();
        }

    }
})();